import logo from "../../assets/images/marcaAccess.png";
import { Container, Image, Title } from "../styled/Home";

const Home = () => {
  return (
    <Container>
      <Image src={logo} alt="logo access" />
      <Title variant="h1">TELEMEDICINA</Title>
    </Container>
  );
};

export default Home;
